module.exports = __webpack_public_path__ + "img/artist-01.aa1835cf.png";